import React, { useState, useEffect } from "react";
import Select, { components } from "react-select";
import '../../styles/ScopePopup.css';
import axiosInstance from "../../axiosInstance"; // ✅ Make sure this path is correct
import { ToastContainer, toast } from "react-toastify";

const ModelPopup = ({ closePopup, editData,triggerReload }) => {
  const [code, setCode] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [scope, setScope] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [valuess, setValues] = useState([]);
  const [operationArea, setOperation] = useState(null);
  const [category, setCategory] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);

  // Fetch edit data
  useEffect(() => {
    if (editData?.id) {
      const fetchData = async () => {
        try {
          const response = await axiosInstance.get(`/costsolution/model/get/${editData.id}`);
          const data = response.data;

          setCode(data.model?.code || "");
          setScope(data.model?.scopeId || "");
          setOperation(data.model?.operationId || "");
          const categoryIds = data.model?.categoryDTOs?.map(cat => cat.id) || [];
          setCategory(categoryIds);
          setIsEditing(true);
        } catch (error) {
          toast.error("Failed to fetching data");
          console.error("Error fetching data:", error);
        }
      };
      fetchData();
    }
  }, [editData?.id]);

  // Submit Handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    const postData = { code, scope, operationArea, category };

    try {
      const url = isEditing
        ? `/costsolution/model/${editData?.id}`
        : `/costsolution/model`;

      const method = isEditing ? "put" : "post";
      const response = await axiosInstance[method](url, postData);

      if (response.data) {
        toast.success(isEditing ? "Model updated successfully!" : "Model saved successfully!");
        triggerReload(); 
        handleClear();
        closePopup();
      } else {
         toast.error("Error: " + (response.data?.message || "Failed to process request"));
      }
    } catch (error) {
      console.error("Error:", error);
       toast.error("Something went wrong!");
    }
  };

  // Clear form
  const handleClear = () => {
    setCode("");
    setScope("");
    setOperation("");
    setCategory([]);
  };

  // Generic data fetcher
  const fetchSuggestions = async (url, setState) => {
    try {
      const response = await axiosInstance.get(url);
      const data = response.data;

      if (data.success && Array.isArray(data.autosuggestion)) {
        setState(data.autosuggestion.map((item) => ({
          label: item.label,
          value: item.value
        })));
      } else {
        setState([]);
      }
    } catch (error) {
      console.error(`Error fetching from ${url}:`, error);
      setState([]);
    }
  };

  // Fetch suggestions on load
  useEffect(() => {
    fetchSuggestions("/costsolution/scope/autosuggestion", setSuggestions);
    fetchSuggestions("/costsolution/operationarea/autosuggestion", setValues);
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axiosInstance.get("/costsolution/category/autosuggestion");
      const data = response.data;

      if (data.success && Array.isArray(data.autosuggestion)) {
        setCategoryOptions(
          data.autosuggestion.map((item) => ({
            label: item.label,
            value: item.value
          }))
        );
      } else {
        setCategoryOptions([]);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      setCategoryOptions([]);
    }
  };

  const CustomOption = (props) => {
    const { data, isSelected } = props;
    return (
      <components.Option {...props}>
        <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
          <span>{data.label}</span>
          {isSelected && <span style={{ color: "green" }}>✔</span>}
        </div>
      </components.Option>
    );
  };

  return (
   
      <div className="scope-creation-popup-overlay">
        <div className="scope-creation-popup-container">
          <div className="scope-creation-popup-header">
            <h2>{isEditing ? 'Edit Model' : 'Create Model'}</h2>
            <button className="close-button" onClick={closePopup}>×</button>
          </div>

          <div className="scope-creation-popup-body">
            <div className="scope-creation-form-group">
              <label htmlFor="code" className="labels">Code</label>
              <input 
                type="text"
                id="code"
                name="code"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                required
                style={{ margin: '0px',fontSize:'12px'}}
              />
            </div>

            <div className="scope-creation-form-group">
              <label htmlFor="scope">Scope</label>
              <Select
                id="scope"
                name="scope"
                options={suggestions}
                value={suggestions.find((s) => s.value === scope) || null}
                onChange={(selected) => setScope(selected?.value || "")}
                placeholder="Select Scope..."
                isSearchable
                styles={{
                  control: (base) => ({
                      ...base,
                      width: '100%',
                      minHeight: '40px',
                      borderRadius: '6px',
                      borderColor: '#D0D6DF',
                      fontSize: '13px',
                      '&:hover': {
                          borderColor: '#454CF2'
                      },
                      
                  }),
                  container: (base) => ({
                      ...base,
                      width: '100%',
                      marginBottom:'15px',
                      
                  }),
                  menu: (base) => ({
                      ...base,
                      fontSize: '13px'
                  })
              }}
              />
            
            </div>

            <div className="scope-creation-form-group">
              <label htmlFor="operationArea" className='operationArea'>Operation Area</label>
              <Select
                id="operationArea"
                name="operationArea"
                options={valuess}
                value={valuess.find(option => option.value === operationArea) || null}
                onChange={(selected) => setOperation(selected?.value || "")}
                placeholder="Select Operation..."
                isSearchable
                styles={{
                  control: (base, state) => ({
                    ...base,
                    width: '100%',
                    minHeight: '37px',
                    borderRadius: '6px',
                    fontSize: '13px',
                    borderColor: state.isFocused ? '#454CF2' : '#D0D6DF',
                    boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                    '&:hover': {
                      borderColor: '#454CF2'
                    }
                  }),
                  container: (base) => ({
                    ...base,
                    width: '100%'
                  }),
                  menu: (base) => ({
                    ...base,
                    fontSize: '13px',
                    
                  }),
                  menuList: (base) => ({
                    ...base,
                    fontFamily:'Work Sans',
                    maxHeight: '150px', // Set same height as menu
                    overflowY: 'auto', // Make list scrollable
                    padding: 0 // Optional: adjust padding
                  }),
                  multiValue: (base) => ({
                    ...base,
                    backgroundColor: '#F0F4F8',
                    borderRadius: '4px',
                    padding: '2px 6px',
                    margin: '2px'
                  }),
                  multiValueLabel: (base) => ({
                    ...base,
                    color: '#19324C',
                    fontSize: '12px',
                    fontWeight: 500
                  }),
                  multiValueRemove: (base) => ({
                    ...base,
                    color: '#19324C',
                    ':hover': {
                      backgroundColor: 'transparent',
                      color: '#ff0000'
                    }
                  })
                }}
              />
            </div>

            <div className="scope-creation-form-group">
              <label htmlFor="category" className="form-lab">Category</label>
              <Select
                id="category"
                name="category"
                options={categoryOptions}
                isMulti
                value={categoryOptions.filter((option) => category.includes(option.value))}
                onChange={(selected) => setCategory(selected.map((item) => item.value))}
                classNamePrefix="custom-select"
                placeholder="Select Category..."
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                 menuPosition="fixed"
                components={{
                  Option: CustomOption,
                  ClearIndicator: () => null
                }}
                styles={{
                  menuPortal: base => ({ ...base, zIndex: 9999 }),
                  control: (base, state) => ({
                    ...base,
                    width: '100%',
                    minHeight: '37px',
                    borderRadius: '6px',
                    fontSize: '14px',
                    borderColor: state.isFocused ? '#454CF2' : '#D0D6DF',
                    boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                    '&:hover': {
                      borderColor: '#454CF2'
                    }
                  }),
                  container: (base) => ({
                    ...base,
                    width: '100%',
                  }),
                  menu: (base) => ({
                    ...base,
                    fontSize: '13px',
                    
                  }),
                  menuList: (base) => ({
                    ...base,
                    fontFamily:'Work Sans',
                    maxHeight: '130px', 
                    overflowY: 'auto', 
                    padding: 0 
                  }),
                  multiValue: (base) => ({
                    ...base,
                    backgroundColor: '#F0F4F8',
                    borderRadius: '4px',
                    padding: '2px 6px',
                    margin: '2px'
                  }),
                  multiValueLabel: (base) => ({
                    ...base,
                    color: '#19324C',
                    fontSize: '12px',
                    fontWeight: 500
                  }),
                  multiValueRemove: (base) => ({
                    ...base,
                    color: '#19324C',
                    ':hover': {
                      backgroundColor: 'transparent',
                      color: '#ff0000'
                    }
                  })
                }}
              />
            </div>
          </div>

          <div className="scope-creation-popup-footer">
            <button type="button" className='scope-clear-button' onClick={handleClear}>Clear</button>
            <button className="scope-submit-button" onClick={handleSubmit}>
              {isEditing ? 'Update' : 'Submit'}
            </button>
          </div>
        </div>
      </div>
  
  );
};

export default ModelPopup;
